import { IForm } from '@/components/types'
export const modalConfig: IForm = {
  formItems: [
    {
      field: 'oldExploitAccount',
      type: 'default',
      label: '原开发账号',
      isDisabled: true
    },
    {
      field: 'newExploitAccount',
      type: 'input',
      label: '新开发账号'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
